import { SetBaseUris } from "core/util/pathsHelper";
SetBaseUris(process.env.FORTIS_CAPITAL_API_BASEURI, undefined);
import("./bootstrap");
